import { createWebHistory, createRouter } from "vue-router";

import MainPage from "@/components/mainPage.vue";
import privacyContent from "@/components/privacyContent.vue";

const routes = [
  {
    path: "/tech/",
    component: MainPage,
  },
  {
    path: "/tech/privacyContent",
    component: privacyContent,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
